
class BaseService {

}

export default BaseService
